export default __webpack_public_path__ + "static/media/icons8-carpentry.92ff3873.svg";